import { render } from "./selectRoleList.vue?vue&type=template&id=920a7e46"
import script from "./selectRoleList.vue?vue&type=script&lang=js"
export * from "./selectRoleList.vue?vue&type=script&lang=js"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__